/**
 * BaleMgmtTagline — Phase 2 polish
 * ─────────────────────────────────────────────────────────────────────────────
 * Mission-statement strip rendered at the top of every Bale Management page.
 * Reminds floor operators, QC, and managers what the whole module is *for*
 * before they look at any number.
 *
 * Used by: router.tsx — wraps every /bale-mgmt/* route via withBaleMgmtFrame().
 */
import { ExperimentOutlined } from '@ant-design/icons'
import { Typography } from 'antd'

const { Text } = Typography

export default function BaleMgmtTagline() {
  return (
    <div
      style={{
        background: 'linear-gradient(90deg, #001529 0%, #003a8c 100%)',
        color: '#fff',
        padding: '10px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        borderBottom: '2px solid #1677ff',
      }}
    >
      <ExperimentOutlined style={{ fontSize: 18, color: '#69c0ff' }} />
      <Text style={{ color: '#fff', fontSize: 13, fontStyle: 'italic', lineHeight: 1.4 }}>
        Bale management is the science of converting{' '}
        <Text strong style={{ color: '#fff' }}>variable cotton</Text>
        {' '}into{' '}
        <Text strong style={{ color: '#fff' }}>stable yarn</Text>
        {' '}at the{' '}
        <Text strong style={{ color: '#fff' }}>lowest safe cost</Text>.
      </Text>
    </div>
  )
}

/** Wraps any page element with the bale-mgmt tagline strip on top.
 *  Used by router.tsx to apply the tagline across all /bale-mgmt/* routes
 *  without modifying each individual page component. */
export function withBaleMgmtFrame(element: React.ReactNode): React.ReactNode {
  return (
    <>
      <BaleMgmtTagline />
      {element}
    </>
  )
}
